import { forwardRef } from "react";
import SceneFrame from "./SceneFrame";
import { getSceneImageProps } from "../sceneAssets";

const Scene3 = forwardRef(function Scene3({ copy, language, isArabic, breakpoint = "desktop" }, ref) {
  const { imageSrc, imageSrcSet, imageSizes } = getSceneImageProps(3, breakpoint);
  return (
    <SceneFrame
      ref={ref}
      sceneId={3}
      imageSrc={imageSrc}
      imageSrcSet={imageSrcSet}
      imageSizes={imageSizes}
      copy={copy}
      language={language}
      isArabic={isArabic}
    />
  );
});

export default Scene3;
